<template>
  <div class="nav " :class=" {nav_top:scrollTop}">
    <div class="logo_box">
      <img src="../assets/logo.png" alt="" v-if="!scrollTop">
      <img src="../assets/LOGO_hei.png" v-else alt="">
    </div>
    <div class="nav_content" :class="{hidden:!pcModelStatus}">
      <ul>
        <li class="item " @click="goTo('Home')"><span class="navActive">HOME</span></li>
        <li class="item ours ">
          <span>Our Products</span>
          <div class="our">
            <div class="items " @click="goTo('Bodys')">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</div>
            <div class="items">SHAMPOO</div>
            <div class="items">BATH & SHOWER GEL</div>
          </div>
        </li>
        <li class="item" @click="goTo('Story')"><span>{{lang=='en'?'STORY & HISTORY':'STORIA'}}</span></li>
        <li class="item" @click="goTo('Contact')"><span>  {{lang=='en'?'CONTACT US':'CONTATTACI'}}</span></li>
      </ul>
    </div>
    <div class="phone-nav-content" v-if="modelStatus" @click="toggleModel">
      <ul>
        <li class="item active"  @click="goTo('Home')">HOME</li>
        <li class="item">OUR PRODCTS</li>
        <li class="item" @click="goTo('Story')">{{lang=='en'?'STORY & HISTORY':'STORIA'}}</li>
        <li class="item" @click="goTo('Contact')">  {{lang=='en'?'CONTACT US':'CONTATTACI'}}</li>
      </ul>
    </div>
    <div class="click_box" @click="toggleModel">
      <div class="top_flag"></div>
      <div class="bottom_flag"></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .content{
    .nav {
      width: 1200px;
     height:80px;
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;
      z-index: 1;

      .logo_box {
        height: 53px;
        width: 60px;
      }

      .nav_content {
        height: 100%;
        box-sizing: border-box;

        .item {
          display: inline-block;

          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
          line-height: 80px;
          position: relative;

          .our {
            position: absolute;
            top: 80px;
            left: -80px;
            width: 260px;
            height: 191px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
            color: #999999;
            box-sizing: border-box;
            font-size: 14px;
            padding: 40px 43px 0;
            display: none;

            div {
              display: block;
              /*margin-bottom: 30px;*/
              height: 50px;
              line-height: 0px;
            }
          }

        }

        .navActive {
          color: #ffffff;
          border-bottom: 1px solid #FFFFFF;
        }

        .ours:hover .our {
          display: block;
        }
      }
      .hidden{
        visibility: hidden;
      }

      .phone-nav-content {
        display: none;
      }

      .click_box {
        height: 30px;
        width: 30px;

        div {
          border-bottom: 1px solid #FFF;
          width: 30px;
          margin-top: 10px;
        }
      }
    }
    .nav_top {
      height: 80px;
      background-color: #ffffff;
      line-height: 80px;

      .nav_content {
        line-height: 80px;

        .item {
          line-height: 80px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;

          .our {
            top: 70px;
          }
        }

        .navActive {
          border-bottom: 1px solid #231815;
          color: #231815;
        }

      }


    }
  }
  @media screen and (max-width: 900) {
    .nav {
      width: 100%;
      height: 0.88rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 .3rem;
      align-items: center;
      box-sizing: border-box;

      .logo_box {
        height: 0.53rem;
        width: 0.6rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .nav_content {
        display: none;

        .item {
          display: inline-block;

          font-size: 0.14rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
        }
      }

      .phone-nav-content {
        display: block;
        background-color: #fff;
        position: fixed;
        left: 0;
        right: 0;
        top: 0.88rem;
        bottom: 0;
        padding:0.78rem 0.4rem;

        ul{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          animation:mymove 1s ;
          position: absolute;
          top: 0.78rem;
          padding-left: 0.4rem;
          @keyframes mymove
          {
            from {left:0;}
            to {left:.4rem;}
          }

          @-webkit-keyframes mymove /*Safari and Chrome*/
          {
            from {left:0;}
            to {left:.4rem;}
          }
          .item{
            height: .48rem;

            font-size: .40rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            margin-top: 1.22rem;
          }
          .active{
            border-bottom:0.01rem solid #999999  ;
          }
        }
      }

      .click_box {
        height: 0.32rem;
        width: 0.32rem;

        div {
          border-bottom: 0.02rem solid #FFF;
          width: 0.32rem;
          margin-top: 0.1rem;
        }
      }
    }
    .nav.nav_top {
      background-image: none;
      background-color: #fff;

      .click_box {
        div {
          border-bottom: 0.02rem solid black;
        }
      }
    }

  }

</style>
<script>
  export default {
    props: {
      scrollTop:Boolean,
      modelStatus:Boolean,
      pcModelStatus:Boolean
    },
    // mounted() {
    //   this.windowWidth=window.document.documentElement.clientWidth;
    //   window.addEventListener('scroll', () => {
    //     const cHeight= document.getElementsByClassName('banner_box')[0].clientHeight
    //     if (document.documentElement.scrollTop > cHeight) {
    //       this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     }else {
    //       this.scrollTop = 0;
    //     }
    //
    //
    //   })
    // },
  }

</script>



// WEBPACK FOOTER //
// src/common/my-header.vue